import React from 'react';
import { Link } from 'react-router-dom';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Groups Article Page
 */
const Groups = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Groups</h1>
                <p className="article-subtitle">
                  Groups are the heart of the WeSplit experience. Discover how shared wallets work, from creation and customization to managing funds and settling expenses.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">What is a Group?</h2>
                  <p className="article-section-intro">
                    In WeSplit, a Group is more than just a list of friends—it is a fully functional <strong>Shared Wallet</strong>. Whether you are planning a trip, managing household bills, or running a project, a Group allows you to pool funds (USDC), track expenses, and settle debts in real-time on the Solana blockchain. Unlike traditional split apps where you track IOUs, WeSplit Groups actually hold the money, making settlements instant and transparent.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Getting Started</h2>
                  <p className="article-section-intro">
                    Ready to collaborate? Setting up a group takes seconds. You can name your group, add a photo, and invite your friends immediately.
                  </p>
                </div>

                <div className="article-subsection">
                  <p>
                    👉 <Link to={getHelpRoute(getHelpArticleRoute('getting-started', 'create-group'))} style={{ color: 'var(--green)', textDecoration: 'underline' }}>Read more: Create Your First Group</Link>
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Managing Your Group</h2>
                  <p className="article-section-intro">
                    Once created, you have full control over the group's environment. You can assign <strong>Admins</strong>, manage member permissions (who can withdraw or spend), and even access advanced features like the <strong>Seed Phrase</strong> for external wallet management or <strong>Degen Mode</strong> for experimental features.
                  </p>
                </div>

                <div className="article-subsection">
                  <p>
                    👉 <Link to={getHelpRoute(getHelpArticleRoute('getting-started', 'manage-group'))} style={{ color: 'var(--green)', textDecoration: 'underline' }}>Read more: Group Settings & Customization</Link>
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Funding the Wallet</h2>
                  <p className="article-section-intro">
                    To start spending, the group needs funds. Members can contribute easily by moving money from their personal WeSplit wallet or by sending crypto from an external exchange directly to the group's public address.
                  </p>
                </div>

                <div className="article-subsection">
                  <p>
                    👉 <Link to={getHelpRoute(getHelpArticleRoute('getting-started', 'top-up-group'))} style={{ color: 'var(--green)', textDecoration: 'underline' }}>Read more: Top Up Your Group</Link>
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Using the Funds</h2>
                  <p className="article-section-intro">
                    The funds in the group are meant to be used. You can withdraw money to reimburse yourself for an expense, or transfer it out to an external wallet if the group's purpose has ended.
                  </p>
                </div>

                <div className="article-subsection">
                  <p>
                    👉 <Link to={getHelpRoute(getHelpArticleRoute('getting-started', 'withdraw-group'))} style={{ color: 'var(--green)', textDecoration: 'underline' }}>Read more: Withdraw from a Group</Link>
                  </p>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Rewards',
                  route: getHelpRoute(getHelpArticleRoute('features', 'rewards'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Groups;
